import { CoinKey, optionState, pointOptionsFor } from '../recognition-points';

const REASON_LABEL = {
  'no-balance': 'saldo insuficiente',
  'over-limit': 'ultrapassa o limite de 300 pontos para esta pessoa nesta fase',
};

type PointsPickerProps = {
  coin: CoinKey;
  value: number | undefined;
  balance: number;
  pointsSent: number;
  onChange: (value: number) => void;
};

/**
 * Seletor de pontos — o coracao da mudanca de regra (FRAC-02).
 *
 * Aparece somente DEPOIS que a categoria e escolhida, e oferece as 5 opcoes da
 * faixa dela, de 20 em 20. Nada vem pre-selecionado: enquanto o jogador nao
 * escolher, o "CONTINUAR" fica desabilitado.
 *
 * Quem decide o que esta habilitado e `recognition-points.ts` — este componente
 * so traduz o estado em aparencia e em texto para o leitor de tela.
 */
export default function PointsPicker({ coin, value, balance, pointsSent, onChange }: PointsPickerProps) {
  return (
    <div className="w-full">
      <p className="font-thin text-white text-sm leading-none mb-3 text-center" tabIndex={0}>
        Agora pontue esse reconhecimento:
      </p>

      <div className="flex flex-row flex-wrap items-center justify-center gap-3" role="group" aria-label="Escolha quantos pontos enviar">
        {pointOptionsFor(coin).map(option => {
          const state = optionState(coin, option, balance, pointsSent);
          const disabled = state !== 'enabled';
          const selected = value === option;

          return (
            <button
              key={option}
              type="button"
              disabled={disabled}
              aria-pressed={selected}
              aria-label={
                disabled
                  ? `${option} pontos. Indisponível: ${REASON_LABEL[state as 'no-balance' | 'over-limit']}`
                  : `Enviar ${option} pontos${selected ? '. Selecionado' : ''}`
              }
              onClick={() => onChange(option)}
              className={`${selected ? 'bg-slate-blue ring-slate-blue text-white' : 'bg-maastricht-blue-2 ring-blue-violet-crayola text-electric-blue'} ${
                value !== undefined && !selected ? 'opacity-50' : ''
              } ${disabled ? 'grayscale' : ''} disabled:opacity-50 ring-2 rounded-xl py-2 px-5 text-base font-normal leading-none`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}
